export default "__VITE_ASSET__100234bc__"